import React from 'react';
import { createPortal } from 'react-dom';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, useRoutes } from "react-router-dom";
import AppRoute from './config/app-route.jsx';
import 'bootstrap/dist/css/bootstrap.min.css';

// bootstrap
import 'bootstrap';

// css
import '@fortawesome/fontawesome-free/css/all.css';
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'react-toastify/dist/ReactToastify.css';
import './index.css';
import './scss/react.scss';
import { store } from "./app/store.js";
import { Provider } from "react-redux";
import { ToastContainer } from 'react-toastify';


const container = document.getElementById('root');
const root = createRoot(container);

function App() {
	let element = useRoutes(AppRoute);
	return element;
}

root.render(
	<BrowserRouter>
		<Provider store={store}>
		{createPortal(
			<ToastContainer
				style={{ zIndex: 200000 }}
				toastStyle={{ zIndex: 200000 }}
			/>,
			document.body
		)}
			<App />
		</Provider>
	</BrowserRouter>
);
